import React from 'react';
import { InputBase } from '@material-ui/core';

const FieldInput: React.FC<{
  value: string;
  placeholder?: string;
  onChange: (v: string) => void;
  style?: React.CSSProperties;
  multiline?: boolean;
  rows?: number;
  readOnly?: boolean;
}> = ({ value, placeholder = '', onChange, style, multiline, rows, readOnly }) => (
  <InputBase
    value={value}
    placeholder={placeholder}
    onChange={(e) => onChange(e.target.value)}
    fullWidth
    multiline={multiline}
    rows={rows}
    style={{
      padding: '7px 14px',
      border: '1px solid #e0e3e8',
      borderRadius: 8,
      fontFamily: "'DM Mono', monospace",
      fontSize: 13,
      color: '#374151',
      backgroundColor: '#fff',
      boxSizing: 'border-box',
      width: '100%',
      ...style,
    }}
    inputProps={{
      style: { padding: 0, verticalAlign: 'top', alignSelf: 'flex-start' },
      readOnly,
    }}
  />
);

export default FieldInput;